import { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { Datepicker } from "./Datepicker";
import {
  EditDatePrivateTour,
  resetOffers,
} from "../../Redux/offerReducer/offerSlice";
import { resetReservations } from "../../Redux/reserveReducer/reserveSlice";

// Formik validation schema
const schema = Yup.object().shape({
  from: Yup.date().required("From date is required"),
});

function ModelEditDate({ itemData, show, handelClose, reserved }) {
  const dispatch = useDispatch();

  const close = () => {
    handelClose();
  };

  //handleChange_From Date handel change
  const FromDateChange = (select) => {
    formik.setFieldValue("from", select);
  };

  const formik = useFormik({
    initialValues: {
      from: itemData?.from || null,
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const data = { id: itemData.id, data: values };
      console.log(data);
      dispatch(EditDatePrivateTour(data));
      if (reserved == 1) {
        dispatch(resetReservations());
      } else if (reserved == 0) {
        dispatch(resetOffers());
      }
      handelClose();
    },
  });

  useEffect(() => {
    formik.setValues({
      from: itemData?.from || null,
    });
  }, [itemData]);

  return (
    <>
      <Modal show={show} onHide={close}>
        <Form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Change Date</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>From</Form.Label>
              <div className="d-flex align-items-center m-2 ">
                <Button
                  className="d-lg-none d-xl-block"
                  variant="light"
                  type="button"
                >
                  <i className="fe fe-calendar lh--9 op-6"></i>
                </Button>
                <Datepicker
                  className="form-control"
                  selected={new Date()}
                  value={itemData.from}
                  onChange={FromDateChange}
                  showTimeSelect
                  dateFormat="Pp"
                />
              </div>
              {/* <div>{formik.touched.country && formik.errors.country}</div> */}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handelClose}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default ModelEditDate;
